// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueOneDatePicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * One datetime picker component
 */
!(function () {
  require('share/utils/Izenda.StringUtilities');
  var React = require('react');
  var DateTimePicker = require('share/components/controls/DateTime/Izenda.DateTimePicker');
  var Constants = require('logic/data/Izenda.ReportDesignerConstants');

  var OperatorValueOneDatePicker = React.createClass({

    propTypes: {
      filterInfo: React.PropTypes.object.isRequired
    },

    /**
      * When change value of datepicker, set state value
      * @param  {string} newVal
      */
    onChange: function (newVal) {
      this.props.onChange([newVal]);
    },

    render: function () {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      var dateString = filterInfo.value && filterInfo.value[0];

      return (
        <DateTimePicker
          onChange={this.onChange}
          value={dateString}
          disabled={props.disabled}
          time={props.time}
          calendar={props.calendar}
          renderInContainer={props.renderInContainer} />
      );

    }
  });

  module.exports = OperatorValueOneDatePicker;
}());



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueOneDatePicker.jsx